//Components
import { APIIsLoggedIn }                 from "../_components/apis-platform-data/_api-is-logged-in";
import { APIGetProfileData }             from "../_components/apis-platform-data/_api-get-profile-data";
import { APICheckSubscriptionHasAccess } from "../_components/apis-platform-data/_api-check-subscription-has-access";
import { APIGetParentClass }             from "../_components/apis-platform-data/_api-get-parent-class";
import { APIGetStudents }                from "../_components/apis-platform-data/_api-get-students";
import { IsUserNotValidRedirections }    from "../_components/_is-user-not-valid-redirections.js";
import { APILoadedCheck }                from "../_components/apis-platform-data/_api-loaded-check";
import { APILogout }                     from "../_components/apis-platform-data/_api-logout";
import { APICancelSubscription }         from "../_components/apis-platform-data/_api-cancel-subscription";
import { DataLoadedCheck }               from "../_components/apis-platform-data/_data-loaded-check";

window.UserProfile = {};
window.rendered = [];
window.$ = jQuery;

$( document ).ready( function () {
	// function_name( callback_function, error_callback_function )
	APIIsLoggedIn( function () {
		const gotloggedin = new CustomEvent( "gotloggedin" );
		document.dispatchEvent( gotloggedin );

		APIGetProfileData( () => {
			const gotprofiledata = new CustomEvent( "gotprofiledata" );
			document.dispatchEvent( gotprofiledata );
		} );

		APICheckSubscriptionHasAccess( function () {
			IsUserNotValidRedirections();
			APIGetParentClass( () => {
				const gotparentclass = new CustomEvent( "gotparentclass" );
				document.dispatchEvent( gotparentclass );
				APIGetStudents( () => {
					const gotstudents = new CustomEvent( "gotstudents" );
					document.dispatchEvent( gotstudents );
					const apiloaded = new CustomEvent( "apiloaded" );
					document.dispatchEvent( apiloaded );
				}, () => {
					const api_error = new CustomEvent( "apierror" );
					document.dispatchEvent( api_error );
				} );
			} );
		} );

	}, () => {
		const gotloggedinerror = new CustomEvent( "gotloggedinerror" );
		document.dispatchEvent( gotloggedinerror );

		IsUserNotValidRedirections();
	 } );

	APILoadedCheck(); // TODO: better to have eventhandler hare
	DataLoadedCheck();

	document.addEventListener( "logout", function () {
		APILogout()
			.then( response => {
				// TODO: its better to call the APIIsLoggedIn by event to check
				Cookie.deleteCookie( "userId" );
				Cookie.deleteCookie( "userCountry" );
				window.UserProfile.has_subscription = false;
				window.UserProfile.is_logged_in = false;
				const loggedout = new CustomEvent( "loggedout" );
				document.dispatchEvent( loggedout );
			} )
			.catch( ( error ) => {
				const apiError = new CustomEvent( "apierror" );
				document.dispatchEvent( apiError );
			} )
			.finally( () => {
				IsUserNotValidRedirections();
				window.location.reload();
			} );
	} );

	document.addEventListener( "cancelsubscription", () => {
		APICancelSubscription()
			.then( responce => {
				const canceledsubscription = new CustomEvent( "canceledsubscription" );
				document.dispatchEvent( canceledsubscription );
			} )
			.catch( error => {
				const apiError = new CustomEvent( "apierror" );
				document.dispatchEvent( apiError );
				console.log( error );
			} );
	} );
} );